// extracted by mini-css-extract-plugin
module.exports = {"container":"labelDisplay_container__Ikgnx","colorSquare":"labelDisplay_colorSquare__2pFD_"};